/**
 * TRANSLATE.ACTIONS
 * Traduction automatique d'un texte
 */

export const generateTranslation = (text: string[], inputLang: string | null, _targetLang: string | null) =>({
  type : 'API',
  payload : {
    method : "POST",
    url : "/public/translate",
    data : {
      text,
      inputLang,
      _targetLang
    }
  }
})